import { useNavigate, useLocation } from "react-router-dom";
import { Package, TrendUp, Receipt } from "@phosphor-icons/react";

const TABS = [
  { key: "/hauls", label: "Hauls", icon: Package },
  { key: "/pnl", label: "P&L", icon: TrendUp },
  { key: "/expenses", label: "Expenses", icon: Receipt },
];

export default function FinanceTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="grid grid-cols-3 border-b-4 border-black" data-testid="finance-tabs">
      {TABS.map(({ key, label, icon: Icon }) => {
        const active = pathname === key;
        return (
          <button
            key={key}
            onClick={() => navigate(key)}
            className={`py-3 flex items-center justify-center gap-1.5 font-heading text-xs font-bold uppercase tracking-wide transition-colors ${
              active
                ? "bg-black text-white"
                : "bg-white text-neutral-500 hover:bg-neutral-100 hover:text-black"
            }`}
            data-testid={`tab-${label.toLowerCase().replace(/[^a-z]/g, "")}`}
          >
            <Icon size={14} weight="bold" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
